import React, { Component } from "react";
import Fetch from "../../utils/fetch";
import {
  Table,
  Modal,
  Button,
  Checkbox,
  List,
  Image,
  message,
  Radio
} from "antd";
import Search from "../../components/auditSearch/driverSearch";
import Loader from "../../components/loader";
import moment from "moment";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "Mobile Number",
    dataIndex: "mobile",
    key: "mobile"
  },
  {
    title: "User Type",
    dataIndex: "userType",
    key: "userType"
  },
  {
    title: "Uploaded On",
    dataIndex: "uploadedOn",
    key: "uploadedOn"
  },

  {
    title: "Audited by user",
    dataIndex: "auditedBy",
    key: "auditedBy",
    render: ({ name, number }) => (
      <>
        <span>{name}</span>
        <br />
        <span>{number}</span>
      </>
    )
  },

  {
    title: "Audited at time",
    dataIndex: "auditedAt",
    key: "auditedAt"
  },
  {
    title: "Complaince Status",
    dataIndex: "auditStatus",
    key: "auditStatus"
  },
  {
    title: "Photos",
    dataIndex: "photos",
    key: "photos",
    render: ({ view, photos, auditStatus, _id, profileImage }) =>
      auditStatus === "COMPLETED" ? (
        <span
          onClick={() => view(photos, auditStatus, _id, profileImage)}
          style={{ color: "orange", cursor: "pointer" }}
        >
          Edit
        </span>
      ) : auditStatus !== "PENDING" ? (
        <span
          onClick={() => view(photos, auditStatus, _id, profileImage)}
          style={{ color: "#1890ff", cursor: "pointer" }}
        >
          View
        </span>
      ) : null
  }
];

class TripReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
      loading: true,
      selectedAttachments: [],
      displayImageSelected: null,
      audits: [],
      showAttachmentModal: false,
      viewData: null,
      modalLoader: true
    };
  }

  async componentDidMount() {
    try {
      const audits = await this.fetchDriverProfile();
      this.setState({
        loading: false,
        audits: audits.tableAudit,
        auditData: audits.response
      });
    } catch (err) {
      console.log(err);
    }
  }

  async fetchDriverProfile() {
    const url = `/workAuditHistory/facialTasks`;
    const options = { method: "post" };
    const response = await Fetch(url, options);

    if (Array.isArray(response) && response.length > 0) {
      const tableAudit = this.formatData(response);
      return { tableAudit, response };
    } else {
      message.error("Nothing To show");
      return { tableAudit: [], response: [] };
    }
  }

  formatData(values) {
    return values.map(value => ({
      key: value._id,
      name: value.name,
      mobile: value.mobileNo,
      uploadedOn: moment(value.profilePhotoDetails.uploadedOn).format(
        "h:mm a, DD MMM YY"
      ),
      auditedBy: {
        number: value.profilePhotoDetails.auditedByUserId
          ? value.profilePhotoDetails.auditedByUser.mobileNo
          : "NA",
        name: value.profilePhotoDetails.auditedByUserId
          ? value.profilePhotoDetails.auditedByUser.name
          : "NA"
      },
      auditedAt: value.profilePhotoDetails.auditedByUserId
        ? moment(value.profilePhotoDetails.auditedAt).format(
            "h:mm a, DD MMM YY"
          )
        : "NA",
      userType: value.userType,
      auditStatus: value.profilePhotoDetails.profilePhotoStatus,
      photos: {
        profileImage: value?.profilePhotoDetails?.primaryProfilePhotoS3Path,
        _id: value._id,
        auditStatus: value.profilePhotoDetails.profilePhotoStatus,
        photos: value.profilePhotoDetails.profilePhotos,
        view: this.viewData
      }
    }));
  }

  viewData = async (photos, auditStatus, _id, profileImage) => {
    let selectedDisplayIndex = null;
    if (profileImage) {
      // get index of profile image in photos array
      selectedDisplayIndex = photos.findIndex(photo => photo === profileImage);
    }
    this.setState({ modalLoader: true });
    const url = `/workAuditHistory/facialTasksImages`;
    const options = { method: "post", data: { photos } };
    const response = await Fetch(url, options);
    this.setState({
      modalLoader: false,
      displayImageSelected: null,
      selectedDisplayIndex,
      selectedUserId: _id,
      attachments: response,
      selectedAuditStatus: auditStatus,
      selectedAttachments: [],
      selectedIndex: 0,
      showAttachmentModal: true
    });
  };

  searchResults = data => {
    if (data) {
      const tableAudit = this.formatData(data);
      this.setState({
        loading: false,
        audits: tableAudit,
        auditData: data
      });
    } else {
      throw new Error("No response");
    }
  };

  markComplain = async isComplain => {
    const {
      selectedUserId,
      selectedAttachments,
      auditData,
      displayImageSelected,
      selectedDisplayIndex
    } = this.state;

    if (isComplain && !displayImageSelected) {
      message.error("Please select a photo to display");
      return;
    }

    const selectedAudit = auditData.filter(data => data._id === selectedUserId);
    const attachments = selectedAudit[0].profilePhotoDetails.profilePhotos;
    const url = `/workAuditHistory/updateFacialTasks`;
    const attachmentName = selectedAttachments.map(index => attachments[index]);
    const primaryProfilePhotoS3Path = attachments[selectedDisplayIndex] || null;
    const options = {
      method: "post",
      data: {
        selectedUserId,
        isComplain,
        primaryProfilePhotoS3Path,
        selectedAttachments: attachmentName
      }
    };

    const response = await Fetch(url, options);
    if (response) {
      message.success("Updated");
      const updatedAudit = response[0];
      const { auditData } = this.state;
      const newAuditData = auditData.map(audit =>
        audit._id === updatedAudit._id ? { ...audit, ...updatedAudit } : audit
      );
      const data = this.formatData(newAuditData);

      this.setState({
        audits: data,
        auditData: newAuditData,
        showAttachmentModal: false
      });
    } else {
      console.log(response);
    }
  };

  updateDisplayImage = async () => {
    const {
      selectedUserId,
      displayImageSelected,
      auditData,
      selectedDisplayIndex
    } = this.state;
    if (!displayImageSelected) {
      message.error("Please select a photo to display");
      return;
    }

    const selectedAudit = auditData.filter(data => data._id === selectedUserId);
    const attachments = selectedAudit[0].profilePhotoDetails.profilePhotos;
    const url = `/user/profilePhoto`;
    const primaryProfilePhotoS3Path = attachments[selectedDisplayIndex] || null;
    const options = {
      method: "post",
      data: {
        selectedUserId,
        primaryProfilePhotoS3Path
      }
    };

    const response = await Fetch(url, options);
    if (response) {
      message.success("Updated");
    } else {
      console.log(response);
    }
  };

  handlePrev = () => {
    this.setState(prevState => ({
      selectedIndex: Math.max(prevState.selectedIndex - 1, 0)
    }));
  };

  handleNext = () => {
    this.setState(prevState => ({
      selectedIndex: Math.min(
        prevState.selectedIndex + 1,
        prevState.attachments.length - 1
      )
    }));
  };

  handleCheckboxToggle = index => {
    this.setState(prevState => {
      const alreadySelected = prevState.selectedAttachments.includes(index);
      const newSelection = alreadySelected
        ? prevState.selectedAttachments.filter(i => i !== index)
        : [...prevState.selectedAttachments, index];
      return { selectedAttachments: newSelection };
    });
  };

  handleRadioChange = (index, item) => {
    this.setState({ displayImageSelected: item, selectedDisplayIndex: index });
  };
  render() {
    const {
      audits,
      loading,
      showAttachmentModal,
      attachments,
      displayImageSelected,
      selectedDisplayIndex,
      selectedAttachments,
      selectedIndex,
      selectedAuditStatus,
      modalLoader
    } = this.state;

    const current = attachments ? attachments[selectedIndex] : 0;
    if (loading) return <Loader />;

    return (
      <div>
        <Search fetched={this.searchResults} />
        <Table
          columns={columns}
          dataSource={audits}
          pagination={false}
          scroll={{ y: "70vh" }}
        />
        {showAttachmentModal ? (
          <Modal
            title="Photo Review"
            visible={showAttachmentModal}
            footer={null}
            width="100%"
            onCancel={() =>
              this.setState({ showAttachmentModal: false, selectedIndex: 0 })
            }
          >
            {modalLoader ? (
              <Loader />
            ) : (
              <>
                <div style={{ display: "flex", gap: "20px" }}>
                  {/* Image Viewer */}
                  <div style={{ flex: 3, textAlign: "center" }}>
                    <Image
                      src={current}
                      style={{ maxHeight: 400, objectFit: "contain" }}
                      preview={false}
                    />
                    <div style={{ marginTop: 10 }}>
                      <Button
                        icon={<LeftOutlined />}
                        onClick={this.handlePrev}
                        disabled={selectedIndex === 0}
                      />
                      <span style={{ margin: "0 16px" }}>
                        {" "}
                        Attachment {selectedIndex + 1}
                      </span>
                      <Button
                        icon={<RightOutlined />}
                        onClick={this.handleNext}
                        disabled={selectedIndex === attachments.length - 1}
                      />
                    </div>
                  </div>

                  <div style={{ flex: 1 }}>
                    <List
                      header={
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                          }}
                        >
                          <b>Attachment</b>
                          <b>Show on Self Help Page</b>
                        </div>
                      }
                      dataSource={attachments}
                      renderItem={(item, index) => (
                        <List.Item
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                          }}
                        >
                          {/* LEFT: Checkbox */}
                          <Checkbox
                            disabled={selectedAuditStatus !== "INREVIEW"}
                            checked={selectedAttachments.includes(index)}
                            onChange={() => this.handleCheckboxToggle(index)}
                          >
                            Attachment {index + 1}
                          </Checkbox>
                          {/* RIGHT: Radio */}
                          <Radio
                            checked={selectedDisplayIndex === index}
                            onChange={() => this.handleRadioChange(index, item)}
                          />
                        </List.Item>
                      )}
                    />
                  </div>
                </div>
                {selectedAuditStatus === "COMPLETED" ? (
                  <div style={{ marginTop: 20, textAlign: "right" }}>
                    <Button
                      type={displayImageSelected ? "primary" : "ghost"}
                      disabled={!displayImageSelected}
                      onClick={() => this.updateDisplayImage()}
                    >
                      Save
                    </Button>
                  </div>
                ) : selectedAuditStatus === "REJECTED" ? null : (
                  <div style={{ marginTop: 20, textAlign: "right" }}>
                    <Button
                      style={{
                        border: null,
                        marginRight: 8,
                        background: "#F7961D",
                        color: "#fff"
                      }}
                      onClick={() => this.markComplain(false)}
                    >
                      Not Complaint
                    </Button>

                    <Button
                      type={
                        selectedAttachments.length > 0 ? "primary" : "ghost"
                      }
                      disabled={selectedAttachments.length === 0}
                      onClick={() => this.markComplain(true)}
                    >
                      Mark as Complaint
                    </Button>
                  </div>
                )}
              </>
            )}
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default TripReview;
